import cx from 'classnames';

import useCreateNewRoomDataContext from './CreateNewRoomDataProvider/useCreateNewRoomDataContext';
import { CreateNewRoomStepsEnum } from './utils';

const progressVariants = {
  [CreateNewRoomStepsEnum.CREATE_ROOM]: 'w-[33%]',
  [CreateNewRoomStepsEnum.INVITE_PARTICIPANTS]: 'w-[66%]',
  [CreateNewRoomStepsEnum.REVIEW_ROOM]: 'w-[95%]',
};

const ProgressBar = () => {
  const { currentStep, hasToReturnToReview, isScheduling, isSchedulingAvailable } = useCreateNewRoomDataContext();

  // We must explicitly check for these cases so that typeScript
  // can infer that currentStep will never be one of the two values.
  const isProgressBarVisible =
    currentStep !== CreateNewRoomStepsEnum.DISCARD && currentStep !== CreateNewRoomStepsEnum.SET_AUTO_REMINDERS;

  if (!isProgressBarVisible || !isScheduling || !isSchedulingAvailable) return null;

  const progressBarVariant = hasToReturnToReview
    ? progressVariants[CreateNewRoomStepsEnum.REVIEW_ROOM]
    : progressVariants[currentStep];

  return (
    <div className="w-full h-1 shrink-0 rounded-xl bg-primary-10">
      <div className={cx('h-full bg-primaryComp-50 rounded-xl', progressBarVariant)} />
    </div>
  );
};

export default ProgressBar;
